module.exports = __webpack_public_path__ + "images/feature/1023_stats_2-0917cf3259a1bf6644630dbe692810ca.jpg";